import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL OPTIONS
export const optionList = (params = '') => Http.get(`/marketing-kpi-options${serialize(params)}`)
export const optionCreate = (params = '') => Http.post('/marketing-kpi-options', params)
export const optionByID = (params = '') => Http.get(`/marketing-kpi-options/${params}`)
export const optionUpdate = (params = '') => Http.put(`/marketing-kpi-options/${params.id}`, params)
export const optionDestroy = (params = '') => Http.delete(`/marketing-kpi-options/${params.id}`)
   
export const optionFormatList = (params = '') => Http.get(`/enum/marketing-kpi-options-formats${serialize(params)}`)
